// these are backend errors, see ether/controller/mobile_common.py
export const SENDER_DUPLICATE_MOBILE = 4
export const INVALID_MOBILE_VERIFICATION = 203
export const NEW_FUND_FILE_REQUIRED = 25
